import { getContentfulClient } from './getContentfulClient';

export function getContentfulContent() {}

export async function getContentByContentType(contentType) {
  const client = getContentfulClient();
  return await client.getEntries({ content_type: contentType });
}

export async function getContentfulEntryByIdOrSlug(idOrSlug, contentType = null) {
  const client = getContentfulClient();
  try {
    return await client.getEntry(idOrSlug);
  } catch (e) {
    // Contentful won't allow a search query across multiple content types
    // so one must be provided to query by slug
    if (contentType !== null && !!e?.message?.match(/resource could not be found/i)) {
      const entries = await client.getEntries({
        'fields.slug': idOrSlug,
        content_type: contentType,
      });

      if (entries.items.length > 0) {
        return entries.items[0];
      }

      throw new Error(`Content with slug "${idOrSlug}" not found.`);
    }
  }
}

export async function getContentfulGuidebookCards() {
  const guidebooks = await getContentByContentType('guidebook');
  return guidebooks.items.map((item) => {
    return {
      id: item.sys.id,
      title: item.fields.title,
      imageUrl: item.fields.cardImage.fields.file.url,
      tags: [],
    };
  });
}

export async function getContentfulArticleCards() {
  const articles = await getContentByContentType('article');
  return articles.items.map((item) => {
    return {
      id: item.sys.id,
      title: item.fields.title,
      imageUrl: item.fields.media.fields.file.url,
      tags: [],
    };
  });
}

export async function getContentfulVideoCards() {
  const videos = await getContentByContentType('video');
  return Promise.all(
    videos.items.map(async (item) => {
      // http://vimeo.com/api/v2/video/713844911.json
      // https://vimeo.com/api/oembed.json?url=https://vimeo.com/728690904/fbef5eb075
      let imageUrl = item.fields.thumbnail?.fields?.file?.url;

      if (!imageUrl) {
        const data = await fetch(
          `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(item.fields.videoUrl)}`,
        ).then((response) => response.json());
        imageUrl = data.thumbnail_url;
      }

      return {
        id: item.sys.id,
        title: item.fields.title,
        imageUrl: imageUrl || 'https://via.placeholder.com/150',
        tags: [],
      };
    }),
  );
}

export async function getContentfulRecipeCards() {
  const recipes = await getContentByContentType('recipe');
  return recipes.items.map((item) => {
    return {
      id: item.sys.id,
      title: item.fields.recipeName,
      imageUrl: item.fields.image.fields.file.url,
      tags: [],
    };
  });
}
export async function getContentfulRecipeCardCards() {
  const recipes = await getContentByContentType('recipe_card');
  return recipes.items.map((item) => {
    return {
      id: item.sys.id,
      title: item.fields.title,
      description: item.fields.description,
      imageUrl: item.fields.thumbnail?.fields?.file?.url || item.fields.image?.fields?.file?.url,
      tags: [],
    };
  });
}
